<template>
  <div class="scheduling-report">
    <h2>Scheduling</h2>
    <el-tabs v-model="selectedWeekName" tab-position="left" type="border-card" v-if="selectedOffice">
      <el-tab-pane
        v-for="(item, index) in weeks"
        :key="index"
        :label="item.weekStartDate.format('L')"
        :name="index.toString()"
      >
        <h3>Week starting {{ item.weekStartDate.format('MMM D, Y') }} based on {{ item.relatedWeekYearPrior.format('MMM D, Y') }}</h3>
        <weekly-scheduling-table :week="item" :office="selectedOffice" :isSelected="index.toString() === selectedWeekName"></weekly-scheduling-table>
      </el-tab-pane>
    </el-tabs>
    <el-alert title="Please select an office." type="warning" show-icon v-else>
    </el-alert>
  </div>
</template>

<script>
import moment from 'moment';
import WeeklySchedulingTable from '@/components/tables/WeeklyScheduling.vue';
import { SEASON } from '@/enum/TaxYear';
import ReportBaseMixin from './ReportBaseMixin';

export default {
  mixins: [ReportBaseMixin],
  components: {
    WeeklySchedulingTable,
  },
  data() {
    const weeks = [];
    for (let i = 1; i < 17; i++) {
      weeks.push({
        weekStartDate: this.getMomentInstanceForYear(SEASON.CURRENT).week(i).startOf('week'),
        relatedWeekYearPrior: this.getMomentInstanceForYear(SEASON.PRIOR).week(i).startOf('week'),
      });
    }
    return {
      weeks,
      selectedWeekName: null,
    };
  },
  methods: {
    getMomentInstanceForYear(year) {
      return moment().year(year).startOf('year');
    },
  },
  mounted() {
    this.selectedWeekName = (this.getMomentInstanceForYear(SEASON.CURRENT).week() - 1).toString(); // current week
  },
};

</script>
